import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON

import { ToastrModule } from 'ngx-toastr';

import { RoutingModule } from './routing.module';
import { MaterialModule } from './material.module';
import { AppConfig } from './app.config';  //CAP-20753: Imported AppConfig file for Client related Changes
import { environment } from 'src/environments/environment';
import { RootComponent } from './../components/root/root.component';
import { IsAliveComponent } from './../components/is-alive/is-alive.component';
import { LoginComponent } from './../components/login/login.component';
import { SubscriptionComponent } from './../components/subscription/subscription.component';
import { ConsultationComponent } from './../components/consultation/consultation.component';
import { PanelComponent } from './../components/panel/panel.component';
import { OperationDetailsDialogBoxComponent } from '../components/operation-details-dialog-box/operation-details-dialog-box.component';
import { SubscriptionValidateDialogBoxComponent } from '../components/subscription-validate-dialog-box/subscription-validate-dialog-box.component';

import { DatePipe } from './../pipes/date.pipe';

import { HttpService } from './../services/http.service';
import { ConsultationService } from './../services/consultation.service';
import { CacheService } from './../services/cache.service';
import { ExcelService } from './../services/excel.service';
import { CsvService } from './../services/csv.service';
import { AuthenticationService } from './../services/authentication.service';
import { SubscriptionService } from './../services/subscription.service';
import { CommonService } from './../services/common.service';
import { NgxSpinnerModule } from "ngx-spinner"; 
import { CacheInterceptorService } from '../services/cacheInterceptorService.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
import { TranslateHttpLoader } from '@ngx-translate/http-loader';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
import { SubscriptionValidatedComponent } from '../components/subscription-validated/subscription-validated.component';  // CAP-26096_POUDG-8493: Lot-2 related changes

//CAP-20457: LOT1.1: START - Translation Service changed to translate for JSON
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
//CAP-20457: LOT1.1: STOP - Translation Service changed to translate for JSON

//CAP-20753: START - Initialising app based on AppConfig File for Client related Changes
export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);  
}
//CAP-20753: STOP - Initialising app based on AppConfig File for Client related Changes

// Define a module for application and also register different components, services and pipes etc
@NgModule({
  declarations: [
    RootComponent,
    LoginComponent,
    SubscriptionComponent,
    ConsultationComponent,
    PanelComponent,
    OperationDetailsDialogBoxComponent,
    SubscriptionValidateDialogBoxComponent,
    SubscriptionValidatedComponent,       // CAP-26096_POUDG-8493: Lot-2 related changes
    IsAliveComponent,
    DatePipe
  ],
  entryComponents: [
    OperationDetailsDialogBoxComponent,
    SubscriptionValidateDialogBoxComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    RoutingModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      closeButton: false,
      timeOut: 5000
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })

  ],
  providers: [
    HttpService,
    ConsultationService,
    SubscriptionService,
    CacheService,
    ExcelService,
    CsvService,
    AuthenticationService,
    DatePipe,
    CommonService,
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptorService,
      multi: true
    }
  ],
  bootstrap: [RootComponent]
})
export class AppModule { }
